import React from 'react';
import { SelectLabel } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export function SeatingModeSelector({ selectedEvent, value, onChange }) {
    const { t } = useTranslation();

    const SELECTION_OPTIONS = [
        { text: t('ticket.widget.seating-options.automatic'), value: 'automatic' },
        { text: t('ticket.widget.seating-options.manual'), value: 'manual' },
        { text: t('ticket.widget.seating-options.hybrid'), value: 'hybrid' }
    ];

    if (!selectedEvent?.chart) {
        return null;
    }

    return <SelectLabel useNew label={t('ticket.widget.seating-options.label')} options={SELECTION_OPTIONS} value={value} onChange={onChange} />;
}
